import { Pipe, PipeTransform } from '@angular/core';
import { LanguageService } from './language.service';

@Pipe({
  name: 'language',
  pure: false
})
export class LanguagePipe implements PipeTransform {

  constructor(private _language:LanguageService) {}

  transform(value:any, args?: any): any {
    return this._language.getTranslation(value);
  }

}
